module.exports = __webpack_public_path__ + "img/prepay-cards.c4d625c.png";